import { useLocales } from '@sevenrooms/locales'
import { VStack } from '@sevenrooms/ui-kit/layout'
import { policyDetailsMessages } from './policyDetailsMessages'
import { PolicyWrapper } from './PolicyWrapper'

export interface PolicyDetailsProps {
  bookingCheckoutPolicy?: string
  cancellationPolicy?: string
  showSpecialAttentionMessage: boolean
  showBookingCheckoutPolicyHeader?: boolean
  dataTestId?: string
}

export function PolicyDetails({
  showSpecialAttentionMessage,
  bookingCheckoutPolicy,
  cancellationPolicy,
  showBookingCheckoutPolicyHeader = true,
  dataTestId,
}: PolicyDetailsProps) {
  const { formatMessage } = useLocales()

  if (!bookingCheckoutPolicy && !cancellationPolicy && !showSpecialAttentionMessage) {
    return null
  }

  return (
    <VStack spacing="l">
      {bookingCheckoutPolicy && (
        <PolicyWrapper
          header={showBookingCheckoutPolicyHeader ? formatMessage(policyDetailsMessages.bookingCheckoutPolicyHeader) : undefined}
          content={bookingCheckoutPolicy}
          dataTest={dataTestId && `booking-${dataTestId}`}
        />
      )}
      {showSpecialAttentionMessage && (
        <PolicyWrapper
          header={formatMessage(policyDetailsMessages.specialAttentionMessageHeader)}
          content={formatMessage(policyDetailsMessages.specialAttentionMessageBody)}
          dataTest={dataTestId && `special-attention-${dataTestId}`}
        />
      )}
      {cancellationPolicy && (
        <PolicyWrapper
          header={formatMessage(policyDetailsMessages.cancellationPolicyHeader)}
          content={cancellationPolicy}
          dataTest={dataTestId && `cancellation-${dataTestId}`}
        />
      )}
    </VStack>
  )
}
